module.exports = __webpack_public_path__ + "img/bag_replace.a0bdb01b.png";